export const settingsOptions = [
    {
        id: 1,
        translationKey: "speciesDatabase",
        path: "species",
    },
    {
        id: 2,
        translationKey: "researchTypes",
        path: "researchType",
    },
    {
        id: 3,
        translationKey: "researchRequirements",
        path: "courses",
    },
    {
        id: 4,
        translationKey: "masterForms",
        path: "masterForm",
    },
    {
        id: 5,
        translationKey: "protocolTemplates",
        path: "protocols",
    },
];
